<template>
	<content-container>
		<section class="allergy-filter-wrapper">
			<span class="allergy-filter-text">Filter by: </span>
			<ul class="allergy-filter-list">
				<li v-for="filter in filters" :key="filter.id">
					<allergy-filter
						:id="filter.id"
						:value="filter.value"
						:icon="filter.icon"
						:label="filter.label"
						:isSelected="isFilterSelected(filter.id)"
						@change="handleFilterChange"
					/>
				</li>
			</ul>
		</section>
	</content-container>
</template>

<script>
import ContentContainer from "./ContentContainer.vue";
import AllergyFilter from "./AllergyFilter.vue";

export default {
	name: "MenuAllergyFilter",
	components: {
		ContentContainer,
		AllergyFilter
	},
	props: {
		allergyFilters: {
			type: Array,
			default: () => []
		},
		selectedAllergyFilters: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			filters: [
				{
					label: "All",
					icon: "null",
					value: true,
					id: "all"
				}
			].concat(this.allergyFilters)
		};
	},
	methods: {
		handleFilterChange(filterId) {
			this.$emit("filterSelected", filterId);
		},
		isFilterSelected(filterId) {
			var filterIndex = this.selectedAllergyFilters.findIndex(
				filter => filter === filterId
			);
			if (filterIndex !== -1) {
				return true;
			} else if (
				this.selectedAllergyFilters.length === 0 &&
				filterId === "all"
			) {
				return true;
			}
			return false;
		}
	}
};
</script>

<style scoped lang="scss">
.allergy-filter-wrapper {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	margin: 20px 0;
}

.allergy-filter-text {
	font-weight: 700;
}

.allergy-filter-list {
	display: flex;
	flex-wrap: wrap;
}
</style>